import { ADD_DATA_WITH_FORCE, ADD_DATA_WITHOUT_FORCE } from "../actions/blocksourceActions";
import { isFulfilled, isPending, isRejected } from "./reducerUtils";

const initalState = {
    blocksourceList: null,
    blocksourceLoading: false,
    blocksourceError: null,
};

const blocksourceReducer = (state = initalState, action) => {
    switch (action.type) {
        case isFulfilled(ADD_DATA_WITHOUT_FORCE):
            return {
                ...state,
                blocksourceList: [...action.payload.blockedSources],
                blocksourceLoading: false,
                blocksourceError: null,
            };
        case isPending(ADD_DATA_WITHOUT_FORCE):
            return { ...state, blocksourceLoading: true, blocksourceError: null };
        case isRejected(ADD_DATA_WITHOUT_FORCE):
            return {
                ...state,
                blocksourceList: null,
                blocksourceLoading: false,
                blocksourceError: action.payload,
            };
        default:
            return state;
    }
};

export default blocksourceReducer;
